module.exports = __webpack_public_path__ + "static/media/tamise.080e8b30.jpg";